// polyfill : todo : move that
(() => {
    if (typeof NodeList.prototype.forEach === "function") {
        return false;
    }
    NodeList.prototype.forEach = Array.prototype.forEach;
})();

import FocusPoint from "./../../../../../node_modules/mth-focuspoint/src/mth-focuspoint";
import Helpers from "./Javascript/Helpers";
import ScrollMonitor from "./Javascript/ScrollMonitor";
import ButtonNext from "./Components/Atom/ButtonNext";
import Slider from "./Components/Organism/Slider";
import Navigation from "./Components/Organism/NavigationPanel";

const init = () => {
    /**
     * @type {ScrollMonitor}
     */
    const scrollMonitor = new ScrollMonitor();

    if (!!document.querySelector(".A-ButtonNext")) {
        const ScrollTo = new ButtonNext(".A-ButtonNext");
        ScrollTo.init();
        scrollMonitor.attachCallback('onScroll', ScrollTo);
    }

    if (!document.querySelector(".neos-backend") && !!document.querySelector(".O-Slider")) {
        const slider = new Slider(".O-Slider", {interval : 6000});
        const sliderEl = slider.getElement();

        sliderEl.addEventListener('mouseover', () => {
            slider.pause();
        });
        sliderEl.addEventListener('mouseout', () => {
            slider.play();
        });

        document.addEventListener('navigationToggle:open', () => {
            slider.pause(true);
            document.querySelector('html').classList.add('no--scroll');
        });
        document.addEventListener('navigationToggle:close', () => {
            slider.play(true);
            document.querySelector('html').classList.remove('no--scroll');
        });

        slider.play();
    }

    if (!!document.querySelector('#Navigation')) {
        const navigation = new Navigation('#Navigation');
        navigation.init();
        scrollMonitor.attachCallback('onScroll', navigation);
    }

    if (!!document.querySelector(".focusItem")) {
        let focusItems = [];

        document.querySelectorAll(".focusItem").forEach((el) => {
            focusItems.push(new FocusPoint(el, {throttleDuration: 80}));
        });
    }
};

Helpers.ready(() => {
    init();
});
